export default (storeState, {payload}) => {
  let newState = Object.assign({}, storeState);

  let date = payload === null ? new Date() : new Date(payload)

  newState.releaseDate = date

  return newState;
};
